import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { customerAvatarsKeys } from './customerAvatarsKeys';
import { useTranslation } from 'react-i18next';

export enum AvatarGender {
  MALE = 'male',
  FEMALE = 'female',
}

export interface IAIAssistantResponse {
  avatarId: string;
  avatarName: string;
  description: string;
  title: string;
  gender: AvatarGender;
  previewImageUrl: string;
  previewVideoUrl: string;
  premium: boolean;
  default: number;
  defaultVoiceId: string;
  tags: string[] | null;
  type: string | null;
  createdAt: string;
  updatedAt: string;
}

const getCustomerAvatars = async (): Promise<IAIAssistantResponse[]> => {
  const response = await EXPRESS_API.get('/customer-avatars');
  return response.data;
};

export const useQueryCustomerAvatars = () => {
  const { t } = useTranslation();
  return useQuery(customerAvatarsKeys.all(), () => getCustomerAvatars(), {
    onError: () => {
      errorToast({
        title: t("We're currently experiencing difficulties fetching agents"),
      });
    },
  });
};
